module.exports = __webpack_public_path__ + "img/di3.d279858c.png";